var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PlacingStateMachine = require("./../../../abstract/stateMachines/placingStateMachine.js");

var TextToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    PlacingStateMachine.call(this, root, editorModel, selectionModel, this.options.multiplePlacing);
};

lib_core.inherit(TextToolStateMachine, PlacingStateMachine);

module.exports = TextToolStateMachine;

TextToolStateMachine.prototype.createElement = function(startCoord) {
    var text = new cio_datamodel.TextData(startCoord, 0, undefined, this.options.font, this.options.fontSize, this.options.fontUnit);

    text.addTo(this.getDataCollection());

    return this.editorModel.interactionModelDataMap.get(text);
};

